"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var tooltip_1 = __importDefault(require("./tooltip"));
var action_1 = __importDefault(require("./action"));
tooltip_1.default.Action = action_1.default;
__export(require("./tooltip"));
exports.default = tooltip_1.default;
//# sourceMappingURL=index.js.map